import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import CommetDetails from "./comment-details";
import { submitFunction } from "../../../shared/submit";
import Pagination from "../../../shared/paigination";

const Comment = () => {
  const [comments, setComments] = useState();
  let _token = useSelector((state) => state.reducer.token);
  const [token, setToken] = useState(_token);

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(15);

  const [numberOfPages, setNumberOfPages] = useState();

  const [indexOfLastPost, setIndexOfLastPost] = useState();
  const [indexOfFirstPost, setّIndexOfFirstPost] = useState();
  const [currentPosts, setCurrentPosts] = useState();

  const [todayVisitorsState, setTodayVisitorsState] = useState();
  const [yesterdayVisitorsState, setYesterdayVisitorsState] = useState();
  const [totalVisitorsState, setTotalVisitorsState] = useState();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getAllVisits`)
      .then((respone) => {
        return respone.json();
      })
      .then((res) => {
        setTodayVisitorsState(res.todayCountVal);
        setYesterdayVisitorsState(res.yesterdayCountVal);
        setTotalVisitorsState(res.totalCountVal);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    let response;
    const func = async () => {
      try {
        response = await submitFunction(
          "/api/comments",
          "POST",
          JSON.stringify({
            page: currentPage,
            pageSize: postsPerPage,
          }),
          token
        );
      } catch (error) {
        console.log(error);
      }
      // console.log("cccccccc", response);
      setNumberOfPages(response.count);
      setComments(response.rows);
      updatePost(response.rows);
    };
    if (token) {
      func();
    }
  }, [
    token,
    setComments,
    setCurrentPosts,
    currentPage,
    indexOfFirstPost,
    indexOfLastPost,
    postsPerPage,
  ]);

  const updatePost = async (data) => {
    setCurrentPosts(data);
  };

  useEffect(() => {
    setIndexOfLastPost(currentPage * postsPerPage);
    setّIndexOfFirstPost(indexOfLastPost - postsPerPage);
  }, [
    currentPage,
    postsPerPage,
    indexOfFirstPost,
    indexOfLastPost,
    currentPosts,
    token,
    comments,
  ]);

  // Change page
  const paginateFront = () => setCurrentPage(currentPage + 1);
  const paginateBack = () => setCurrentPage(currentPage - 1);

  return (
    <div>
      <div
        className=" flex flex-row-reverse justify-between  w-2/3 mx-auto px-4 py-2
        screen1000:w-full  screen600:text-xs
      "
      >
        <div className="text-[#4b7744] font-semibold">
          <span>بازدید امروز : </span>
          <span>{todayVisitorsState}</span>
        </div>
        <div className="text-[#f8be13] font-semibold">
          <span>بازدید دیروز : </span>
          <span>{yesterdayVisitorsState}</span>
        </div>
        <div className="text-[#4b7744] font-semibold screen400:hidden">
          <span>بازدید کل : </span>
          <span>{totalVisitorsState}</span>
        </div>
      </div>
      <div
        style={{ direction: "rtl" }}
        className="font-IRANSansWeb flex
        my-4  justify-center mx-2 font-bold text-white bg-[#f8be13] rounded-lg py-6 text-[13px] 
        caret-transparent  screen800:py-3 screen600:text-[11px]
      "
      >
        <div className=" w-[30%]">ایمیل</div>
        <div className=" w-[10%]">تاریخ</div>
        <div className="w-[50%]">نظر </div>
      </div>
      {currentPosts &&
        currentPosts.map((Element) => {
          return (
            <CommetDetails
              key={Element.id}
              email={Element.email}
              comment={Element.comment}
              date={Element.createdAt}
            />
          );
        })}
      <div className="my-10">
        {comments && (
          <Pagination
            postsPerPage={postsPerPage}
            totalPosts={numberOfPages}
            paginateBack={paginateBack}
            paginateFront={paginateFront}
            currentPage={currentPage}
          />
        )}
      </div>
    </div>
  );
};

export default Comment;
